package gr.tech.GRAttestation.styles

import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

fun Modifier.bsInputLabelStyle(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .classNames("form-label", "mb-1", "text-body")
}

fun Modifier.bsInputStyle(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .classNames("form-control", "mb-1")
}

fun Modifier.bsCheckSmallInputStyle(): Modifier {
    return this
        .height(20.px).width(20.px)
        .fontFamily(FONT_FAMILY)
        .classNames("form-check-input", "me-1", "mt-0")
}

fun Modifier.bsCheckInputLabelStyle(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .classNames("form-label", "text-body", "mb-0")
}

fun Modifier.bsInputErrorTextStyle(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .classNames("form-text", "text-danger", "mt-1", "small")
}

fun Modifier.bsInputErrorOutlineStyle(): Modifier {
    return this
        .fontFamily(FONT_FAMILY)
        .classNames("form-control", "is-invalid")
}

fun Modifier.flexRow(): Modifier {
    return this.classNames("d-flex", "flex-row", "align-items-center", "gap-2")
}

fun Modifier.flexColumn(): Modifier {
    return this.classNames("d-flex", "flex-column", "align-items-center", "gap-2")
}

fun Modifier.bsBtnPrimaryStyle(): Modifier {
    return this.classNames("btn", "btn-primary")
}

fun Modifier.bsBadgeStyle(): Modifier {
    return this.classNames("badge", "bg-light", "text-dark") // me-1/margin-end and mb-1 for spacing
}


/* ------------------------------------- */


val InputContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .margin(bottom = 4.px)
    }
}

val GeneralFormErrorTextStyle = CssStyle {
    base {
        Modifier
            .height(20.px)
            .fontFamily(FONT_FAMILY)
            .fontWeight(FontWeight.Medium)
            .fontSize(0.8.cssRem)
            .color(Colors.Red)
            .fontStyle(FontStyle.Italic)
            .margin(0.px)
    }
}

val GeneralInputLabelStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontWeight(FontWeight.Medium)
            .fontSize(1.cssRem)
    }
}

val GeneralInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(40.px)
            .noBorder()
            .backgroundColor(Theme.HalfGray.rgb)
            .outline(1.px, LineStyle.Solid, Colors.DarkGrey)
            .borderRadius(6.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.cssRem)
            .padding(left = 4.px)
            .color(Colors.Black)
    }
}

val GeneralInputErrorStyle = CssStyle {
    base {
        Modifier
            .outline(1.px, LineStyle.Solid, Colors.Red)
    }
}